module.exports = __webpack_public_path__ + "img/1715650271521-WhatsApp Image 2024-05-14 at 09.14.41.jpeg.9b348e64.webp";